import { marked } from 'marked'
import DOMPurify, { type Config } from 'dompurify'

/**
 * Markdown -> HTML sanitizado (serie LGPD).
 *
 * E o MESMO renderer para a tela de aceite, as paginas publicas e o preview do admin:
 * o hash gravado no aceite e do Markdown, nao do HTML, mas o que o usuario le tem de
 * ser igual nos tres lugares. `marked` em modo GFM; `DOMPurify` porque o corpo vem do
 * banco (redigido pelo admin) e Markdown aceita HTML cru.
 */
marked.use({ gfm: true, breaks: false })

const PURIFY_CONFIG: Config = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ['target', 'rel'],
  FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form', 'input'],
}

/** Links externos abrem em nova aba sem vazar `opener`. */
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('href')?.startsWith('http')) {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

export function renderMarkdown(markdown: string): string {
  const html = marked.parse(markdown ?? '', { async: false }) as string
  return DOMPurify.sanitize(html, PURIFY_CONFIG)
}
